import { createSlice } from "@reduxjs/toolkit";
import { getProducts } from "../actions/fluxoNSimilar";

interface ProductsState {
  sessionProducts: any | null;
  sessionProductsSelect: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: null;
}

const initialState: ProductsState = {
  sessionProducts: null,
  sessionProductsSelect: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};
const sessionProductsSlice = createSlice({
  name: "sessionProducts",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
    clearProducts(state) {
      state.sessionProductsSelect = null;
    },
    selectProduct(state, action) {
      state.sessionProductsSelect = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.status = "error";
        state.sessionProducts = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionProducts = action.payload;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear, clearProducts, selectProduct } =
  sessionProductsSlice.actions;
export default sessionProductsSlice.reducer;
